<template>
  <VisitStepper class="visits" />
</template>

<script>
import { mapActions } from 'vuex'
import { ACTION_GET_PROFILE } from '../store/types/profile.types'
import VisitStepper from '../components/visits/VisitStepper'

export default {
  name: 'VisitsPage',
  components: {
    VisitStepper,
  },
  mounted() {
    this.getProfile()
  },
  methods: {
    ...mapActions({
      getProfile: ACTION_GET_PROFILE,
    }),
  },
}

</script>

<style lang="stylus" scoped>
  .visits {
      height: 100%;
      overflow: auto;
      display: flex;
      flex-flow: column;
      padding: 0 10%;
  }
  @media only screen and (max-width: 480px) {
      .visits {
        padding: 0 5%;
      }
  }
</style>
